import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styles from './index.less';
const SelectPart = (props) => {
  const { data = [], callBack, activeCity, activeRegion } = props;
  return (
    <>
      <div className={styles.selectPart}>
        {data.map((item, index) => (
          <div
            className={`${styles.item} ${
              activeCity === item || activeRegion === item ? styles.itemActive : ''
            }`}
            onClick={() => {
              callBack && callBack(item);
            }}
            key={index}
          >
            {item}
          </div>
        ))}
      </div>
      <div className={styles.selectPartBg}></div>
    </>
  );
};
export default SelectPart;
// export default MovieDetail
